
import { Vue, Component, Prop } from 'vue-property-decorator';
import moment from 'moment';
import { TrackingScan, TrackingSubStatus } from '@/features/shipment-history/types';

@Component
export default class TrackingScanItem extends Vue {
  @Prop({ required: true }) scan!: TrackingScan;

  @Prop({ default: false }) isCurrent!: boolean;

  get scanDate(): string {
    return moment(this.scan.scanTime).format('MMM D, YYYY');
  }

  get scanTime(): string {
    return moment(this.scan.scanTime).format('h:mm A');
  }

  get highlightIcon(): boolean {
    return !!(this.scanIcon && this.isCurrent);
  }

  get scanIcon(): string {
    const iconByStatus = {
      [TrackingSubStatus.Created]: 'mdi-flag-variant',
      [TrackingSubStatus.Pickup]: 'mdi-truck-delivery',
      [TrackingSubStatus.InTransit]: 'mdi-truck-delivery',
      [TrackingSubStatus.Weather]: 'mdi-weather-snowy-rainy',
      [TrackingSubStatus.OutForDelivery]: 'mdi-human-dolly',
      [TrackingSubStatus.Lost]: 'mdi-magnify',
      [TrackingSubStatus.Damaged]: 'mdi-exclamation-thick',
      [TrackingSubStatus.Customs]: 'mdi-exclamation-thick',
      [TrackingSubStatus.Exception]: 'mdi-exclamation-thick',
      [TrackingSubStatus.Delivered]: 'mdi-check-bold',
      [TrackingSubStatus.Returned]: 'mdi-arrow-u-down-left',
      [TrackingSubStatus.ReceiverNotAvailable]: 'mdi-door-closed-lock',
    };

    return iconByStatus[this.scan.substatus] || '';
  }

  get scanIconClasses(): { [key: string]: boolean } {
    const base = 'tracking-scan-item__icon';
    const classes = {
      [base]: true,
      [`${base}--current`]: this.highlightIcon,
      [`${base}--${this.scan.status.toLowerCase()}`]: this.highlightIcon,
    };

    return classes;
  }
}
